import React from 'react';

import styles from './skeleton.scss';

const ELEMENTS_COUNT = 6;

export const TabBar2Skeleton = () => {
  return (
    <div className={styles.wrapper}>
      {new Array(ELEMENTS_COUNT).fill(0).map((_, index) => (
        // eslint-disable-next-line react/jsx-key
        <div key={index} className={styles.item} style={{ maxWidth: `${100 / ELEMENTS_COUNT}%` }}>
          <div className={styles.placeholder} />
        </div>
      ))}
    </div>
  );
};

TabBar2Skeleton.displayName = 'TabBar2Skeleton';
